import { CONFIG } from "@/config";
import { SubscriptionPlan } from "./SubscriptionPlan";
import pluto from "@/assets/img/d_pluto.png";
import neptun from "@/assets/img/d_neptun.png";
import uran from "@/assets/img/d_uran.png";
import bgSubscription from "@/assets/img/bg_subscription.png";  
import { SubscriptionPlansType, SubscriptionPlanType } from "../SubscriptionScreenViewModel";

interface SubscriptionScreenFreeProps {
  onSelectPlan: (isAutoContinuation: boolean, subscriptionPlan: SubscriptionPlanType) => void;
  plans: SubscriptionPlansType;
  openOffertsUrl: () => void;
}
const SubscriptionScreenFree = ({
  onSelectPlan,
  plans,
  openOffertsUrl,
}: SubscriptionScreenFreeProps) => {
  return (


    <div
      className="grid w-full relative"
      style={{
        gridTemplateColumns: "1fr 1fr",
        gridTemplateRows: "1fr 1fr 1fr 1fr 1fr 50px",
        gap: "10px",
        minWidth: "420px",
        maxWidth: "500px",
        width: "100%",
        height: "100%",
        aspectRatio: "1/1",
      }}
    >
      <img
        src={bgSubscription}
        alt="stars"
        className="w-full h-full absolute top-0 left-0"
      />
      {plans && (
        <>
          <SubscriptionPlan
            plan={plans.month_price}
            key={plans.month_price.duration}
            planetUrl={pluto}
            className=" object-contain "
            onSuccessSelection={onSelectPlan}
            style={{ gridRow: "1/3", gridColumn: "1" }}
          />
          <SubscriptionPlan
            plan={plans.month_3_price}
            key={plans.month_3_price.duration}
            planetUrl={neptun}
            className=" object-contain "
            onSuccessSelection={onSelectPlan}
            style={{ gridRow: "2/4", gridColumn: "2" }}
          />
          <SubscriptionPlan
            plan={plans.month_6_price}
            key={plans.month_6_price.duration}
            planetUrl={uran}
            className=" object-contain"
            onSuccessSelection={onSelectPlan}
            style={{ gridRow: "3/5", gridColumn: "1" }}
          />
          <SubscriptionPlan
            plan={plans.year_price}
            key={plans.year_price.duration}
            planetUrl={pluto}
            className=" object-contain"
            onSuccessSelection={onSelectPlan}
            style={{ gridRow: "4/6", gridColumn: "2" }}
          />
          <div
            className="flex flex-col items-center justify-center p-4  z-10"
            style={{ gridRow: "5/7", gridColumn: "1/3" }}
          >
            <div className="text-white text-sm text-center ">
              Почта для связи:{" "}
              <a
                href={`mailto:${CONFIG.links.supportEmail}`}
                className="underline text-cyan-300"
              >
                {CONFIG.links.supportEmail}
              </a>
            </div>
            <div className="text-white text-sm text-center ">
              Совершая покупки вы соглашаетесь с{" "}
              <a
                href="#"
                className="underline text-cyan-300"
                onClick={openOffertsUrl}
              >
                Договором публичной оферты
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SubscriptionScreenFree;